var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconEyeHidden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.6248 4.575C10.3798 4.185 10.0998 3.835 9.8098 3.52L7.9248 5.405C7.9848 5.59 8.0198 5.79 8.0198 6C8.0198 7.12 7.1148 8.02 5.9998 8.02C5.7898 8.02 5.5898 7.985 5.4048 7.925L3.6748 9.655C4.4048 10.065 5.1948 10.28 5.9998 10.28C6.8898 10.28 7.7548 10.02 8.5448 9.535C9.3348 9.045 10.0448 8.33 10.6248 7.42C11.1248 6.64 11.1248 5.36 10.6248 4.575Z",
    fill: "#8D8E97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00982 4.99001L4.98982 7.01001C4.73482 6.75001 4.56982 6.39001 4.56982 6.00001C4.56982 5.21501 5.20982 4.57001 5.99982 4.57001C6.38982 4.57001 6.74982 4.73501 7.00982 4.99001Z",
    fill: "#8D8E97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.125 2.875L7.43 4.57C7.065 4.2 6.56 3.98 6 3.98C4.88 3.98 3.98 4.885 3.98 6C3.98 6.56 4.205 7.065 4.57 7.43L2.88 9.125H2.875C2.32 8.675 1.81 8.1 1.375 7.42C0.875 6.635 0.875 5.36 1.375 4.575C1.955 3.665 2.665 2.95 3.455 2.46C4.245 1.98 5.11 1.715 6 1.715C7.115 1.715 8.195 2.125 9.125 2.875Z",
    fill: "#8D8E97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43004 5.99999C7.43004 6.78499 6.79004 7.42999 6.00004 7.42999C5.97004 7.42999 5.94504 7.42999 5.91504 7.41999L7.42004 5.91499C7.43004 5.94499 7.43004 5.96999 7.43004 5.99999Z",
    fill: "#8D8E97"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8849 1.115C10.7349 0.965002 10.4899 0.965002 10.3399 1.115L1.11494 10.345C0.964941 10.495 0.964941 10.74 1.11494 10.89C1.18994 10.96 1.28494 11 1.38494 11C1.48494 11 1.57994 10.96 1.65494 10.885L10.8849 1.655C11.0399 1.505 11.0399 1.265 10.8849 1.115Z",
    fill: "#8D8E97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconEyeHidden);
export default __webpack_public_path__ + "static/media/common_icon_eye_hidden.7f019239b6988dd34253cdbafc5644ed.svg";
export { ForwardRef as ReactComponent };